import { render, staticRenderFns } from "./aliMaPay.vue?vue&type=template&id=de7b0fde&scoped=true&"
import script from "./aliMaPay.vue?vue&type=script&lang=js&"
export * from "./aliMaPay.vue?vue&type=script&lang=js&"
import style0 from "./aliMaPay.vue?vue&type=style&index=0&id=de7b0fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b0fde",
  null
  
)

export default component.exports